import { render } from "./SariangPenyakit.vue?vue&type=template&id=1bf5d98a"
import script from "./SariangPenyakit.vue?vue&type=script&lang=js"
export * from "./SariangPenyakit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__